<script setup>
const { $get } = useAxios();
const { locale } = useI18n();
const route = useRoute();
const { data: coin } = await useAsyncData(
  `get coin by id - ${route.params.id}-${locale}`,
  () => $get(`/coins/${route.params.id}`),
  { lazy: true, default: () => {} }
);
</script>
<template>
  <NuxtLayout name="default">
    <div v-if="coin" class="mb-14">
      <a-coin-preview :coin="coin"></a-coin-preview>
      <a-coin-description :coin="coin" class="mt-8 md:mt-14"></a-coin-description>
      <a-coins-popular class="mt-6 md:mt-14"></a-coins-popular>
    </div>
  </NuxtLayout>
</template>

<style scoped>
.buttonCss:hover {
  background-color: #f0f0f0;
}
</style>
